import React, { useState } from 'react';
import { Dumbbell, Lock } from 'lucide-react';
import { supabase } from '../supabaseClient';
import { useTheme } from '../contexts/ThemeContext';

export function ResetPasswordForm() {
  const { theme } = useTheme();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }
    setLoading(true);
    setError(null);

    try {
      const { error } = await supabase.auth.updateUser({ password });
      if (error) throw error;
      setSuccess(true);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className={`min-h-screen ${theme.bg} ${theme.text} flex items-center justify-center p-4`}
      style={{
        paddingTop: 'calc(env(safe-area-inset-top) + 1rem)',
        paddingBottom: 'calc(env(safe-area-inset-bottom) + 1rem)',
        paddingLeft: 'calc(env(safe-area-inset-left) + 1rem)',
        paddingRight: 'calc(env(safe-area-inset-right) + 1rem)',
      }}
    >
      <div className={`w-full max-w-md ${theme.card} rounded-xl p-6 sm:p-8 border ${theme.border}`}>
        <div className="flex items-center justify-center gap-3 mb-6">
          <Dumbbell className="w-8 h-8 text-blue-500" />
          <h1 className="text-2xl font-bold">Groso.app</h1>
        </div>

        <h2 className="text-xl font-semibold text-center mb-6">Nueva Contraseña</h2>

        {success ? (
          <div className="p-3 rounded-lg bg-green-500/20 text-green-400 text-sm text-center">
            Contraseña actualizada. Ya podés usar la app.
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className={`block text-sm font-medium mb-2 ${theme.textSecondary}`}>
                Nueva contraseña
              </label>
              <div className="relative">
                <Lock className={`absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 ${theme.textSecondary}`} />
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value.slice(0, 50))}
                  required
                  placeholder="••••••••"
                  minLength={6}
                  maxLength={50}
                  className={`w-full pl-10 pr-4 py-3 rounded-lg border ${theme.input}`}
                />
              </div>
            </div>

            <div>
              <label className={`block text-sm font-medium mb-2 ${theme.textSecondary}`}>
                Confirmar contraseña
              </label>
              <div className="relative">
                <Lock className={`absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 ${theme.textSecondary}`} />
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value.slice(0, 50))}
                  required
                  placeholder="••••••••"
                  minLength={6}
                  maxLength={50}
                  className={`w-full pl-10 pr-4 py-3 rounded-lg border ${theme.input}`}
                />
              </div>
            </div>

            {error && (
              <div className="p-3 rounded-lg bg-red-500/20 text-red-400 text-sm">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 rounded-lg bg-blue-600 text-white font-medium hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              {loading ? (
                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
              ) : (
                'Guardar contraseña'
              )}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
